import Controller from './controller';
import { on } from '../helpers';
import View from './view';

const initPage = () => {
    const view = new View();
    const controller = new Controller(view);
    controller.resetView();
}

on(window, 'load', initPage);
